import React, { Component } from "react";
import Nav from "./nav/Nav";
class Header extends Component {
  render() {
    return (
      <header>
        <Nav />
      </header>
    );
  }
}

export default Header;
